export default function truncateDelta(delta, maxLength = 160) {
  if (!delta || !delta.ops || delta.ops.length === 0) {
    return delta;
  }

  let totalLength = 0;
  const truncatedOps = [];
  let wasTruncated = false;

  for (const op of delta.ops) {
    if (typeof op.insert !== 'string') {
      // Handle non-text inserts (like embeds)
      continue;
    }

    const insertText = op.insert;
    const remainingLength = maxLength - totalLength;

    if (remainingLength <= 0) {
      wasTruncated = true;
      break;
    }

    if (insertText.length + totalLength <= maxLength) {
      // The entire operation fits
      truncatedOps.push(op);
      totalLength += insertText.length;
    } else {
      // Need to truncate this operation
      const truncatedText = insertText.substring(0, remainingLength);
      truncatedOps.push({
        ...op,
        insert: truncatedText,
      });
      totalLength += truncatedText.length;
      wasTruncated = true;
      break;
    }
  }

  // Add ellipsis if content was truncated
  if (wasTruncated && truncatedOps.length > 0) {
    const lastOp = truncatedOps[truncatedOps.length - 1];
    if (typeof lastOp.insert === 'string') {
      lastOp.insert = lastOp.insert.trimEnd() + '...';
    } else {
      truncatedOps.push({ insert: '...' });
    }
  }

  return {
    ops: truncatedOps,
  };
}
